const regexReservedChars = /[.?*+^$[\]\\(){}|-]/g;

export const regexEscape = (string) => {
    return string.toString().replace(regexReservedChars, '\\$&');
};

export default regexEscape;
